import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import 'react-loading-skeleton/dist/skeleton.css'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { GlobalStyle } from 'styles/global-styles'
import { AdminOverViewPage } from './adminpages/AdminOverview'
import { NotFoundPage } from './components/NotFoundPage/Loadable'
import { useToken } from './hooks'

import { AdminUsersPage } from './adminpages/AdminUsers'

import { AdminBalancePage } from './adminpages/AdminBalance'
import { AdminCashPage } from './adminpages/AdminCash'
import { AdminCoinPage } from './adminpages/AdminCoin'
import { AdminEventsPage } from './adminpages/AdminEvents'
import { AdminMemberResponsePage } from './adminpages/AdminMemberResponse'
import { AdminPositionPage } from './adminpages/AdminPosition'
import { AdminPriceCheckPage } from './adminpages/AdminPriceCheck'
import { AdminRecordDetailsPage } from './adminpages/AdminRecordDetails'
import { AdminSystemPage } from './adminpages/AdminSystem'
import { AdminTicketPage } from './adminpages/AdminTicket'
import { AdminTransactionPage } from './adminpages/AdminTransaction'
import { AdminUserGroupPage } from './adminpages/AdminUserGroup'
import { NotFoundPageFake } from './components/NotFoundPageFake'
import { APPNAME } from './constants/APIKEYS'
import { useDevKey } from './hooks/auth/devkey'
import { useExchangeStore } from './hooks/trade/exchangeStore'
import { LoginPage } from './pages/AuthenticationPages/LoginPage'
import BannedPage from './pages/BannedPage'
import EmptyPage from './pages/EmptyPage'
import './styles.css'
import PGDepositPage from './adminpages/AdminCash/PGDepositPage'
import PGWithdrawPage from './adminpages/AdminCash/PGWithdrawPage'
export function Routes() {
	const { i18n } = useTranslation()
	const { data: token, mutate } = useToken()
	const { data: devkey } = useDevKey()

	const { EPs } = useExchangeStore()

	console.log(token, "token")
	console.log("EPs", EPs)

	return (
		<BrowserRouter>
			<Helmet
				titleTemplate="%s"
				defaultTitle={APPNAME + ' BACKOFFICE'}
				htmlAttributes={{ lang: i18n.language }}>
				<meta name="description" content="GLOBAL BACKOFFICE" />
			</Helmet>

			<Switch>
				<Route exact path="/logout" component={EmptyPage} />


				{!devkey && <Route path="*" component={NotFoundPageFake} />}

				{!token && <Route path="*" component={LoginPage} />}

				<Route exact path="/banned" component={BannedPage} />
				<Route
					exact
					path="/login/"
					component={token ? AdminOverViewPage : LoginPage}
				/>

				<Route
					exact
					path="/"
					component={token ? AdminOverViewPage : LoginPage}
				/>

				<Route
					exact
					path="/usergroup/"
					component={AdminUserGroupPage}
				/>
				<Route
					exact
					path="/usergroup/*"
					component={AdminUserGroupPage}
				/>

				<Route exact path="/users/" component={AdminUsersPage} />
				<Route exact path="/users/*" component={AdminUsersPage} />

				<Route exact path="/position/*" component={AdminPositionPage} />
				<Route exact path="/coin/*" component={AdminCoinPage} />

				<Route
					exact
					path="/record/*"
					component={AdminRecordDetailsPage}
				/>
				<Route
					exact
					path="/transaction/*"
					component={AdminTransactionPage}
				/>
				<Route exact path="/cash/*" component={AdminCashPage} />

				<Route exact path="/ticket" component={AdminTicketPage} />
				<Route exact path="/ticket/*" component={AdminTicketPage} />

				<Route exact path="/balance" component={AdminBalancePage} />
				<Route exact path="/balance/*" component={AdminBalancePage} />
				<Route exact path="/events/" component={AdminEventsPage} />
				<Route exact path="/events/*" component={AdminEventsPage} />
				<Route
					exact
					path="/price-check"
					component={AdminPriceCheckPage}
				/>
				<Route exact path="/system" component={AdminSystemPage} />
				<Route exact path="/system/*" component={AdminSystemPage} />

				<Route exact path="/cash/pg/deposit" component={PGDepositPage} />
				<Route exact path="/cash/pg/withdraw" component={PGWithdrawPage} />
				<Route
					exact
					path="/member-response"
					component={AdminMemberResponsePage}
				/>
				<Route path="*" component={NotFoundPage} />
			</Switch>
			<GlobalStyle />
		</BrowserRouter>
	)
}
